import type { Dispatch } from "redux";

import { REQUEST_STATUSES } from "@/constants";
import { MediaShareService } from "@/services";
import type { ThunkDispatch } from "@/store/hooks";

import * as types from "./types";

export const getCurrentMediaShare = (propertyId: number, shareId: number) => {
  return async (dispatch: ThunkDispatch) => {
    dispatch({
      type: types.SET_CURRENT_MEDIA_SHARE_STATUS,
      payload: { propertyId, id: shareId, status: REQUEST_STATUSES.LOADING },
    });

    try {
      const { resp, status, err } = await MediaShareService.getPublicMediaShare(+propertyId, +shareId);

      dispatch({
        type: types.GET_CURRENT_MEDIA_SHARE,
        payload: {
          mediaShare: resp,
          status,
          err,
        },
      });
    } catch (err: unknown) {
      dispatch({ type: types.SET_CURRENT_MEDIA_SHARE_STATUS, payload: { status: REQUEST_STATUSES.FAILED, err } });
    }
  };
};

export const updateCurrentMediaShareOpened = (propertyId: number, mediaShareId: number, hasOpened: boolean) => {
  return async (dispatch: Dispatch) => {
    try {
      const { resp, status, err } = await MediaShareService.updatePublicMediaShare(propertyId, mediaShareId, {
        hasOpened,
      });

      dispatch({ type: types.UPDATE_CURRENT_MEDIA_SHARE_OPENED, payload: { mediaShare: resp, status, err } });
    } catch (err: unknown) {
      dispatch({ type: types.SET_CURRENT_MEDIA_SHARE_STATUS, payload: { status: REQUEST_STATUSES.FAILED, err } });
    }
  };
};
